<template>
  <div class="wrapper">
    <div class="inside">
      <div class="assign-department-wrapper">
        <div class="toggles-box">
          <div class="flex-col control">
            <h3 style="margin-top: 0">
              {{ $t("profile.add_user.choose_type") }}
            </h3>

            <div class="flex checkbox-wrapper">
              <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked1"
                  name="userRole"
                  @change="() => ((isAdmin = false), (isWorker = false), (isOwner = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked1"> {{ $t("profile.add_user.owner") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${router.currentRoute.value.query.type.toLowerCase()}.owner`) }}</p>

              <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked2"
                  name="userRole"
                  @change="() => ((isOwner = false), (isWorker = false), (isAdmin = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked2"> {{ $t("profile.add_user.admin") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${router.currentRoute.value.query.type.toLowerCase()}.admin`) }}</p>

              <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked3"
                  name="userRole"
                  @change="() => ((isAdmin = false), (isOwner = false), (isWorker = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked3"> {{ $t("profile.add_user.worker") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${router.currentRoute.value.query.type.toLowerCase()}.worker`) }}</p>
            </div>

            <div v-show="showUsersError && !isAdmin && !isOwner && !isWorker" class="control__error role-error">
              <div class="control__error-inner">{{ $t("missings.missing_role") }}</div>
            </div>

            <!-- <div v-if="router.currentRoute.value.query.type === 'PILOT'" class="licenses-section">
              <h4>{{ $t("profile.add_user.licenses") || "Licencje" }}</h4>
              <div class="licenses-wrapper">
                <div v-for="licenseType in licenseTypes" :key="licenseType" class="license-item">
                  <div class="license-checkbox">
                    <input
                      type="checkbox"
                      :id="`license-${licenseType}`"
                      v-model="selectedLicenses[licenseType].selected"
                      @change="onLicenseToggle(licenseType)"
                    />
                    <label :for="`license-${licenseType}`" class="license-label">
                      {{ $t(`enums.${licenseType}`) }}
                    </label>
                  </div>

                  <div v-if="selectedLicenses[licenseType].selected" class="license-file-input">
                    <label class="control-label" :for="`file-${licenseType}`">
                      {{ $t("profile.add_user.upload_license_document") || "Dodaj dokument licencji" }}
                    </label>
                    <div class="file-input-wrapper">
                      <label class="file__button" :for="`file-${licenseType}`" tabindex="0">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path
                            d="M16.4996 9.00009L9.74965 15.7501C5.24965 20.2501 -1.50035 13.5001 2.99965 9.00009L9.74965 2.25009C12.7496 -0.749911 17.2496 3.75009 14.2496 6.75009L7.49965 13.5001C5.99965 15.0001 3.74965 12.7501 5.24965 11.2501L11.9996 4.50009"
                            stroke="#112BAF"
                            stroke-width="1.5"
                          />
                        </svg>
                        {{ $t("profile.add_documents.choose_file") || "Wybierz plik" }}
                      </label>
                      <input
                        :id="`file-${licenseType}`"
                        type="file"
                        @change="(e) => onLicenseFileInput(e, licenseType)"
                        accept=".png,.pdf,.jpg,.jpeg,.doc,.docx"
                      />
                      <span v-if="!selectedLicenses[licenseType].file" class="no-file-text">
                        {{ $t("profile.add_documents.no_files_chosen") || "Nie wybrano pliku" }}
                      </span>
                      <span v-if="selectedLicenses[licenseType].file" class="file-name">
                        {{ selectedLicenses[licenseType].file.name }}
                      </span>
                    </div>
                    <div
                      v-if="selectedLicenses[licenseType].selected && !selectedLicenses[licenseType].file && showLicenseError"
                      class="control__error license-file-error"
                    >
                      <div class="control__error-inner">
                        {{ $t("profile.add_user.license_file_required") || "Dokument licencji jest wymagany" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!hasSelectedLicenses && showLicenseError" class="control__error license-selection-error">
                <div class="control__error-inner">
                  {{ $t("profile.add_user.at_least_one_license") || "Wybierz przynajmniej jedną licencję" }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="large_box">
        <h4>{{ $t("profile.add_user.enter_worker_data") }}</h4>
        <form>
          <div class="">
            <div class="form-positioning">
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("admin.profile.email") }}</label>
                <input type="text" id="address" v-model="email" />
                <div v-show="errors.email" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.email }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.phone") }}</label>
                <input @keyup="phoneNumber = phoneNumber.replace(/\D/g, '')" id="phone-number-input" type="text" v-model="phoneNumber" />
                <div v-show="errors.phoneNumber" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.name") }}</label>
                <input type="text" id="address" v-model="name" />
                <div v-show="errors.name" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.name }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.surname") }}</label>
                <input type="text" id="address" v-model="surname" />
                <div v-show="errors.surname" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.surname }}
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleFormControlTextarea1">{{ $t("profile.add_user.message") }}</label>
                <textarea v-model="message" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                <div v-show="errors.message" class="control__error textarea-control-error">
                  <div class="control__error-inner">
                    {{ errors.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="buttons">
      <button class="button-outline" @click.prevent="addNewUser">
        <template v-if="!userStore.isLoading">
          {{ $t("profile.add_user.add") }}
        </template>
        <template v-else>
          {{ $t("profile.add_user.adding") }}
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import NoDepartmentScreen from "@/components/common/NoDepartmentScreen.vue";
import Menu from "@/components/Menu";
import ChangePassword from "@/components/settings/ChangePassword";
import Privacy from "@/components/settings/Privacy";
import AlertHelper from "@/helpsers/alert.helper";
import { typeOfCompany } from "@/js/utils";
import UserLayout from "@/layouts/UserLayout";
import router from "@/router";
import { useDepartmentStore } from "@/stores/department.store";
import { useHelpersStore } from "@/stores/helpers.store";
import { useUserStore } from "@/stores/user.store";
import { storeToRefs } from "pinia";
import { useField, useForm } from "vee-validate";
import { computed, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
export default {
  name: "AddWorkerToCompanyAdmin",
  components: { Privacy, ChangePassword, Menu, UserLayout, NoDepartmentScreen },
  setup() {
    const userStore = useUserStore();
    const { justAddedWorker } = storeToRefs(userStore);
    const departmentStore = useDepartmentStore();
    const helpersStore = useHelpersStore();
    let { currentWarehouses } = storeToRefs(departmentStore);
    let width = ref(window.innerWidth);
    let loading = ref(false);
    let showDepartmentError = ref(false);
    let showUsersError = ref(false);
    let showLicenseError = ref(false);
    let alert = inject("alert");
    let chosenDepartments = ref(currentWarehouses);
    // License types from enum
    const licenseTypes = ["BF2", "BF3", "BF3_PLUS", "BF4", "VLM"];

    // Selected licenses object
    const selectedLicenses = ref({
      BF2: { selected: false, file: null },
      BF3: { selected: false, file: null },
      BF3_PLUS: { selected: false, file: null },
      BF4: { selected: false, file: null },
      VLM: { selected: false, file: null },
    });

    // Computed property to check if at least one license is selected
    const hasSelectedLicenses = computed(() => {
      return Object.values(selectedLicenses.value).some((license) => license.selected);
    });

    const onLicenseToggle = (licenseType) => {
      if (!selectedLicenses.value[licenseType].selected) {
        // If unchecking, remove the file
        selectedLicenses.value[licenseType].file = null;
      }
    };

    const onLicenseFileInput = (e, licenseType) => {
      const file = e.target.files[0];
      if (file) {
        if (file.size <= 10_000_000) {
          // 10MB limit
          selectedLicenses.value[licenseType].file = file;
        } else {
          AlertHelper.show(alert, "Plik jest za duży. Maksymalny rozmiar to 10MB.", "", "error");
          e.target.value = ""; // Reset input
        }
      }
    };

    // Function to validate licenses
    const validateLicenses = () => {
      return true;
      // Check if at least one license is selected
      if (!hasSelectedLicenses.value) {
        showLicenseError.value = true;
        return false;
      }

      // Check if all selected licenses have files
      for (const [licenseType, license] of Object.entries(selectedLicenses.value)) {
        if (license.selected && !license.file) {
          showLicenseError.value = true;
          return false;
        }
      }

      showLicenseError.value = false;
      return true;
    };

    onMounted(async () => {
      let id = router.currentRoute.value.query.companyId;
      await departmentStore.fetchAllWarehouses({
          id: id,
        });
      var inputBox = document.getElementById("phone-number-input");
      inputBox.onchange = function () {
        inputBox.value = inputBox.value.replace(/[^0-9]/g, "");
      };
    });

    const { t } = useI18n();
    const { handleSubmit, errors, handleReset } = useForm({
      validationSchema: yup.object().shape({
        email: yup
          .string()
          .trim()
          .required(t("register.validation.email"))
          .email(t("register.validation.email"))
          .max(50, t("register.validation.max", { number: 50 })),
        message: yup.string().max(500, t("register.validation.max", { number: 500 })),
        name: yup
          .string()
          .trim()
          .required(t("register.validation.required"))
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+$/, t("register.validation.string"))
          .max(30, t("register.validation.max", { number: 30 })),
        surname: yup
          .string()
          .trim()
          .required(t("register.validation.required"))
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+$/, t("register.validation.string"))
          .max(50, t("register.validation.max", { number: 50 })),
        phoneNumber: yup
          .string()
          .required(t("register.validation.required"))
          .matches(
            /^(?=(.{1,20})$)((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/,
            t("register.validation.phone")
          ),
        isAdmin: yup.boolean(),
        isOwner: yup.boolean(),
        isWorker: yup.boolean(),
      }),
      initialValues: {
        email: "",
        message: "",
        name: "",
        surname: "",
        phoneNumber: "",
        isAdmin: false,
        isOwner: false,
      },
    });

    const { value: name } = useField("name");
    const { value: surname } = useField("surname");
    const { value: phoneNumber } = useField("phoneNumber");
    const { value: email } = useField("email");
    const { value: isAdmin } = useField("isAdmin");
    const { value: isOwner } = useField("isOwner");
    const { value: isWorker } = useField("isWorker");
    const { value: message } = useField("message");

    const addNewUser = handleSubmit(async () => {
      // Validate licenses first
      if (!validateLicenses() && router.currentRoute.value.query.type === "PILOT") {
        AlertHelper.show(alert, t("profile.company.please_pick_one_licence"), "", "error");
        return;
      }
          console.log(currentWarehouses.value, "@");

      if (chosenDepartments.value.length > 0 || isOwner.value) {
        if (isOwner.value || isWorker.value || isAdmin.value) {
          userStore.isLoading = true;
          const data = {
            email: email.value,
            name: name.value,
            surname: surname.value,
            phoneNumber: phoneNumber.value,
            role: isAdmin.value ? "ADMINISTRATOR" : isOwner.value ? "OWNER" : isWorker.value ? "WORKER" : "",
            companyId: router.currentRoute.value.query.companyId,
            licenses: Object.entries(selectedLicenses.value)
              .filter(([_, license]) => license.selected)
              .map(([licenseType, license]) => ({
                type: licenseType,
                file: license.file,
              })),
          };
          if (message.value !== "") data.message = message.value;
          try {
            await userStore.addUser(data);
            helpersStore.adjustTasks();
            userStore.isLoading = false;
            const licensesKeys = Object.keys(selectedLicenses.value);

            if (!isOwner.value) {
              await Promise.all(
                chosenDepartments.value.map(async (department) => {
                  const obj = {
                    alert,
                    email: email.value,
                    departmentId: department.id,
                    role: "ADMINISTRATOR",
                  };
                  return departmentStore.addWorkerToDepartment(obj, true);
                })
              );
            }
            // licensesKeys.forEach(async (el) => {
            //   const license = selectedLicenses.value[el];
            //   if (!license.selected) return;
            //   const obj = {
            //     userId: justAddedWorker.value.id,
            //     type: el,
            //     file: license.file,
            //     companyId: router.currentRoute.value.query.companyId,
            //   };
            //   await userStore.addUserLicenses(obj, true);
            // });
            AlertHelper.show(alert, t("profile.company.addWorker"));
            handleReset();
            // Reset licenses
            Object.keys(selectedLicenses.value).forEach((key) => {
              selectedLicenses.value[key] = { selected: false, file: null };
            });
            router.push({ name: "list-users" });
          } catch (e) {
            userStore.isLoading = false;
            console.log(e);
            AlertHelper.show(alert, e, "", "error");
          }
        } else {
          showUsersError.value = true;
        }
      } else {
        showDepartmentError.value = true;
        AlertHelper.show(alert, "Przypisz pracownika do oddziału", "Aby dodać pracownika do firmy, musisz przypisać go do oddziału.", "error");
      }
    });

    const toggleDepartment = (department) => {
      if (chosenDepartments.value.includes(department)) {
        chosenDepartments.value.splice(chosenDepartments.value.indexOf(department), 1);
      } else {
        chosenDepartments.value.push(department);
      }
    };

    const isChecked = (department) => {
      return chosenDepartments.value.includes(department);
    };

    function validate(evt) {
      var theEvent = evt || window.event;
      if (theEvent.type === "paste") {
        key = event.clipboardData.getData("text/plain");
      } else {
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }

    return {
      loading,
      validate,
      email,
      isAdmin,
      errors,
      addNewUser,
      message,
      userStore,
      isOwner,
      isWorker,
      name,
      surname,
      phoneNumber,
      currentWarehouses,
      width,
      chosenDepartments,
      showDepartmentError,
      toggleDepartment,
      typeOfCompany,
      showUsersError,
      isChecked,
      // License related
      licenseTypes,
      selectedLicenses,
      hasSelectedLicenses,
      onLicenseToggle,
      onLicenseFileInput,
      validateLicenses,
      showLicenseError,
      router,
    };
  },
};
</script>

<style scoped lang="scss">
@use "@/css/other-screens/add-user-view.scss";

.textarea-control-error {
  left: unset;
  bottom: unset;
}

.wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  max-width: unset !important;
  overflow-y: auto;
  padding-bottom: 50px;
  @media screen and (max-width: 2200px) {
    flex-direction: column;
  }
  @media screen and (max-width: 850px) {
    padding: 0 20px;
  }
  overflow-x: hidden;
  .inside {
    display: flex;
    margin-top: 30px;
    max-width: 1400px;
    min-width: 1000px;
    margin: auto;
    @media screen and (max-width: 1200px) {
      min-width: 700px;
    }
    @media screen and (max-width: 1000px) {
      min-width: unset !important;
      flex-direction: column;
      align-items: center;
    }
  }
  h2,
  h3,
  h4 {
    font-weight: 600;
    color: #112baf;
    font-size: 14px;
  }
}

.checkbox-wrapper {
  gap: 10px;
  flex-direction: column;
  align-items: start;
  margin-top: 20px;
  @media screen and (max-width: 575px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}

.form-group label {
  font-size: 12px;
  font-weight: 400;
}

#exampleFormControlTextarea1 {
  max-width: 500px;
  font-size: 14px;
}

#exampleFormControlTextarea1:focus {
  outline: none !important;
}

.assign-department-wrapper {
  position: relative;
  top: 0px;
  width: 50%;
  @media screen and (max-width: 600px) {
    width: 90%;
  }
  h2,
  h3,
  h4 {
    margin-top: 20px;
  }
}

.toggles-box {
  margin-top: 30px;
  max-width: 500px;
  .flex-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.make-invisible {
  opacity: 0.1;
}

input[type="checkbox"],
input[type="radio"] {
  accent-color: #112baf;
}

.primary-label {
  font-weight: 600;
  color: #112baf;
  font-size: 14px;
}

.large_box {
  min-width: unset !important;
  max-width: unset !important;
  min-height: unset !important;
  max-width: unset !important;
  width: 50%;
  max-height: 550px !important;
  h2,
  h3,
  h4 {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 600px) {
    padding: 20px 0;
    width: 90%;
  }
}

.form-switch {
  padding: 0;
}

.form-switch .form-check-input {
  width: 16px;
  background-image: unset;
}

form .form-positioning label {
  font-weight: 600;
  font-size: 12px;
  color: rgba(5, 24, 52, 0.6);
}

.buttons {
  .button-outline {
    margin: 100px auto 0 auto;
    background-color: #112baf;
    color: white;

    @media screen and (max-width: 600px) {
      margin: 20px auto;
    }
  }
}

.control--input input {
  max-width: unset;
}

.return-btn-in-container {
  left: 0;
  border: 1px solid red;
}

.form-check-label {
  font-size: 14px;
  font-weight: 600;
}

.role-description {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  margin-left: 30px;
  color: rgba(31, 34, 47, 0.6);
}

.error-departments {
  min-width: 200px;
  padding: 5px 15px;
  background-color: #f28787;
  color: #fff;
  font-size: 1.2rem;
  line-height: 15px;
  max-width: 327px;
  border-radius: 15px;
  width: 100%;
  transform: translateY(100%);
  margin-top: -20px;
  margin-bottom: 20px;
  z-index: 2;
  &-inner {
    position: relative;
  }
  &::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 50%;
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 10px 15px;
    border-color: transparent transparent #f28787 transparent;
    transform: translateX(-50%);
  }
}

textarea {
  background: rgba(17, 43, 175, 0.04) !important;
  border: none !important;
  border-radius: 10px;
  width: 100%;
  max-width: unset !important;
}

/* Licenses Section Styles */
.licenses-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(162, 162, 162, 0.3);
  width: 100%;
  h4 {
    margin-bottom: 20px;
    font-weight: 600;
    color: #112baf;
    font-size: 14px;
  }
}

.licenses-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.license-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  background: rgba(17, 43, 175, 0.02);
  border-radius: 10px;
  border: 1px solid rgba(162, 162, 162, 0.2);
}

.license-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #112baf;
  }

  .license-label {
    font-weight: 600;
    font-size: 14px;
    color: #112baf;
    cursor: pointer;
  }
}

.license-file-input {
  margin-left: 28px;

  .control-label {
    display: block;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: rgba(5, 24, 52, 0.6);
    margin-bottom: 8px;
  }
}

.file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;

  input[type="file"] {
    display: none;
  }

  .file__button {
    cursor: pointer;
    background: rgba(17, 43, 175, 0.04);
    border-radius: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.03em;
    color: #112baf;
    padding: 12px;
    display: flex;
    gap: 7px;
    width: fit-content;
    border: 1px solid rgba(17, 43, 175, 0.2);
    transition: all 0.2s ease;
    min-width: 140px !important;
    &:hover {
      background: rgba(17, 43, 175, 0.08);
    }
  }

  .no-file-text {
    font-weight: 400;
    font-size: 12px;
    color: rgba(5, 24, 52, 0.6);
  }

  .file-name {
    font-weight: 500;
    font-size: 12px;
    color: #112baf;
    background: rgba(17, 43, 175, 0.1);
    padding: 5px 10px;
    border-radius: 5px;
  }
}

.control__error {
  position: absolute;
  top: 0;
  max-height: 60px !important;

  .control__error-inner {
    color: #fff;
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 8px;
    position: relative;
    max-height: 60px !important;

    &::before {
      content: "";
      position: absolute;
      top: 15px;
      left: 15px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      max-height: 60px !important;
    }
  }
}
</style>
